import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FF5F00",
  d: "M15.167 2.788H8.836V13.21h6.331z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#EB001B",
  d: "M9.488 8c0-1.004.225-1.994.66-2.897a6.6 6.6 0 0 1 1.851-2.314 6.53 6.53 0 0 0-6.938-.75 6.6 6.6 0 0 0-2.699 2.445 6.67 6.67 0 0 0 0 7.033 6.6 6.6 0 0 0 2.7 2.446 6.53 6.53 0 0 0 6.937-.75 6.6 6.6 0 0 1-1.851-2.315A6.66 6.66 0 0 1 9.488 8"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F79E1B",
  d: "M22.01 12.108v-.214h.092v-.044h-.217v.044h.086v.214zm.423 0v-.258h-.066l-.077.184-.076-.184h-.066v.258h.047v-.196l.072.168h.049l.071-.168v.196zM22.64 8a6.67 6.67 0 0 1-1.003 3.517 6.6 6.6 0 0 1-2.7 2.445 6.53 6.53 0 0 1-6.938-.751 6.6 6.6 0 0 0 1.851-2.315 6.67 6.67 0 0 0 0-5.794A6.6 6.6 0 0 0 12 2.788a6.53 6.53 0 0 1 6.938-.751 6.6 6.6 0 0 1 2.7 2.445 6.67 6.67 0 0 1 1.002 3.516z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }